// src/pages/public/usePlayerWikiTab.js — the browser tab of /terms and /privacy reads as
// PlayerWiki, not the console's "Polyp" (2026-10-28, the owner's call): playerwiki.org's
// Terms / Privacy links and both apps land on these two pages. Swaps the tab title and
// every icon <link> to playerwiki.org's favicon while mounted, and puts them back on the
// way out, so the rest of the console keeps its own (index.html's light + dark icons).
import { useEffect } from "react";

const PW_ICON = "https://playerwiki.org/favicon-32.png";

export default function usePlayerWikiTab(title) {
  useEffect(() => {
    const prevTitle = document.title;
    const icons = Array.from(document.querySelectorAll('link[rel~="icon"], link[rel="apple-touch-icon"]'));
    const prevHrefs = icons.map((l) => l.getAttribute("href"));
    document.title = title;
    icons.forEach((l) => l.setAttribute("href", PW_ICON));
    return () => {
      document.title = prevTitle;
      icons.forEach((l, i) => l.setAttribute("href", prevHrefs[i]));
    };
  }, [title]);
}
